import React from "react";

// import Footer from "./components/Footer";
import Hero from "./components/Hero";
import LandingPage from "./components/LandingPage/LandingPage";
// import Navbar from "./components/Navbar/Navbar";
import TrackingPage from "./components/TrackingPage/TrackingPage";
import { BrowserRouter, Routes, Route } from "react-router-dom";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/vehicles" element={<LandingPage />} />
        <Route path="/track/:tripId" element={<TrackingPage />} />
        <Route path="/old" element={<Hero />} />
        <Route path="/" element={<LandingPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
